
import { Component, Vue } from "vue-property-decorator";
import appconst from "@/lib/appconst";

@Component({
  name: "Page404"
})
export default class extends Vue {
  private message = "已退出登录！";
  private appName = appconst.app.defaultName;
}
